const { formatISO, } = require('date-fns');
const { sortBy, flatten, get, } = require('lodash');

const adminFields = () => {
  return {
    adminNote: {
      type: 'text',
      label: '注文memo',
    },
  };
};

// 注文の初回出荷日を返す（未出荷なら null）
const firstShippedAt = (order) => {
  const { inventoryType = 'fba', } = order;
  return ({
    fba: () => {
      const shipments = flatten([get(order, 'FulfillmentShipment.member', [])]).filter(_ => _);
      const [firstShipment] = sortBy(shipments.map(_ => get(_, 'ShippingDateTime')), _ => _);
      return firstShipment != null ? new Date(firstShipment) : null;
    },
    hanropluslogi: () => {
      const shippedAt = order.logispShippingRequest?.shippingItems?.map(_ => _.shippedOn != null && new Date(_.shippedOn)).filter(_ => _)[0];
      return shippedAt || null;
    },
  })[inventoryType]();
};

// 売上計上済みの注文を対象月から除外する。
// Amazonが後から出荷日を書き換えることがあり、過去月に計上済みの注文が
// 当月の出荷日になって二重計上されるのを防ぐ。
// salesMonth を持つ注文はその月の計算時のみ対象とし、他の月では除外する。
const notCountedInOtherMonth = (order, targetMonth) => {
  if(order.salesMonth == null) return true;
  if(targetMonth == null) return true;
  return order.salesMonth === targetMonth;
};

// targetMonth ('yyyy-MM') を渡すと、他の月で売上計上済みの注文を除外する
const firstShippedOrders = (orders, startOn, endOn, targetMonth = null) => {
  return orders
    .filter(_ => notCountedInOtherMonth(_, targetMonth))
    .filter((order) => {
      const shippedAt = firstShippedAt(order);
      return shippedAt != null && startOn <= shippedAt && (endOn == null || shippedAt <= endOn);
    });
};

// NOTE: OrderShipping作成後completeするまでの間もstatusはWAITING_FOR_SHIPPINGのままなので、
// statusだけでは未発送と判定できない
const mercariUnshippedQuantity = (order) =>
  (get(order, 'source.products') ?? []).reduce((x, _) => x + (_.unshippedQuantity ?? 0), 0);

// NOTE: orderTransactions移行前に保存された注文には数量フィールドが無いため、
// その場合のみ従来どおりstatusだけで判定する
const isMercariReadyToShip = (order) => {
  if(get(order, 'source.status') !== 'WAITING_FOR_SHIPPING') return false;
  const hasQuantityFields = (get(order, 'source.products') ?? []).some(_ => _.unshippedQuantity != null);
  return hasQuantityFields ? mercariUnshippedQuantity(order) > 0 : true;
};

module.exports = {
  statuses: {
    initial: '未処理',
    processed: '処理済み',
    cancelled: 'キャンセル済み',
  },
  firstShippedOrders,
  firstShippedAt,
  notCountedInOtherMonth,
  adminFields,
  mercariUnshippedQuantity,
  isMercariReadyToShip,
};
